import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CapabilitiesMarquee from "@/components/CapabilitiesMarquee";
import Services from "@/components/Services";
import Showcase from "@/components/Showcase";
import Process from "@/components/Process";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-[#050505] text-white">
      <Navbar />
      <Hero />
      <CapabilitiesMarquee />
      <Services />
      <Showcase />
      <Process />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
